/* eslint-disable react/jsx-max-depth */
import { _2dMapCombinedQuote } from '@larki/shared/type/order.v2';
import { JobT } from '@larki/shared/types/job.type';
import { upperCase } from 'lodash';
import { Link } from 'react-router-dom';
import { softwares } from '../../../components/mapView/constants';
import Activity from '../../../components/timeline/Activity';
import text from '../../../text';
import Section from './Section';
import {
  splitQuoteDataIntoCards,
  requestForQuoteGroups,
  getIsEssentialUserFor,
  redistributeOverriddenItems,
} from './utils';
import useUser from '@/mp/hooks/useUser';
import { UserT } from '@larki/shared/types/user.type';

const QuoteCreated = ({
  title = 'QUOTE CREATED',
  quote,
  softwareId,
  job,
  layoutSwitch = {
    isSoftwareHidden: false,
    isTermsHidden: false,
    isRfqNoteHidden: false,
  },
  createdUser,
}: {
  title?: string;
  quote: _2dMapCombinedQuote;
  softwareId?: string | null;
  job: JobT;
  layoutSwitch?: {
    isSoftwareHidden?: boolean;
    isTermsHidden?: boolean;
    isRfqNoteHidden?: boolean;
  };
  createdUser: UserT;
}) => {
  const currentUser = useUser();
  const softwareName = softwareId
    ? softwares.entities[softwareId as keyof typeof softwares.entities]?.name
    : null;

  const { buyNowQuote, buyNowCustomOrders } = redistributeOverriddenItems(quote);
  const cards = splitQuoteDataIntoCards(buyNowQuote, 0, requestForQuoteGroups);
  const hasBuyNowSection = cards.length > 0 || buyNowCustomOrders.length > 0;

  const quoteHasMembmership = cards.some((card) => card.title === 'Membership');

  const isCreatedByCurrentUser =
    createdUser?.id != null && createdUser.id === currentUser.profile?.id;

  const creatorIsEssentialUser = isCreatedByCurrentUser
    ? currentUser.isEssentialUser || currentUser.isGovernment
    : getIsEssentialUserFor(createdUser);

  const isEssentialUser = quoteHasMembmership || creatorIsEssentialUser;

  return (
    <div className='InvoiceActivity'>
      <div className='mb-2 font-weight--600 font-18'>
        <Activity.Card.Type type={title} />
      </div>

      <hr className='totals-divider mt-0' />

      {hasBuyNowSection && (
        <Section
          cards={cards}
          totals={buyNowQuote.totals}
          quote={quote}
          isEssentialUser={isEssentialUser}
          title={text('buyItems', {
            title: upperCase(text('buyNow')),
          })}
          totalsPrefix={''}
          customOrders={buyNowCustomOrders}
        />
      )}

      <br />

      {!!layoutSwitch.isRfqNoteHidden && (
        <p className='pt-1 mb-3 grey-3'>{text('rfqNote')}</p>
      )}

      {!layoutSwitch.isSoftwareHidden && (
        <div className='mb-3 mt-2'>
          <span className='font-weight-bold'>{text('software')}: </span>
          <span>{softwareName} </span>
        </div>
      )}

      {!layoutSwitch.isTermsHidden && (
        <div className='terms-and-conditions'>
          {text('orderSubjectAgreement', {
            link: (
              <Link
                key='urlTerms'
                to={{ pathname: process.env.LARKI_URL_TERMS }}
                target='_blank'
              >
                Customer {text('termsAndConditions')}
              </Link>
            ),
          })}
        </div>
      )}
    </div>
  );
};

export default QuoteCreated;
